import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-unused-expressions */
/* eslint-disable no-return-assign */
import React, { useEffect } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useHistory, useLocation } from "react-router";
import squareLogo from "Images/profile/squareLogo.svg";
import SiteLinks from "../../Navigation/SiteLinks";
import styles from "./styles.module.scss";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import RoundedGainfulButton from "../RoundedGainfulButton";
import UserIcon from "../UserIcon";
import Button from "../Button";
import { useSelector } from "react-redux";
const Header = ({ setProfileActive, setMainActive, profileActive, mainActive, toggleActive, userLoggedIn, userName, referralCTACopy = "Refer Friends", }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const history = useHistory();
    const location = useLocation();
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        if (anchorEl) {
            setAnchorEl(null);
        }
        else {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = (link) => {
        if (typeof link === "string") {
            if (location.pathname.indexOf("app") !== -1) {
                history.push(link);
            }
            else {
                window.location.href = link;
            }
        }
        setAnchorEl(null);
    };
    const hasBannerData = useSelector((state) => !!state.profileSeasonalPromotion.bannerData.code);
    const user = useSelector((state) => state.user);
    const siteMenuLinks = [
        { name: "Home", link: userLoggedIn ? "/app/home" : "/home/" },
        {
            name: "Products",
            link: "/app/products/",
            additionalLinks: userLoggedIn
                ? undefined
                : [
                    { name: "Protein", link: "/shop/protein/" },
                    { name: "Hydration", link: "/shop/hydration/" },
                    { name: "Pre-Workout", link: "/shop/preworkout/" },
                    { name: "Greens", link: "/shop/greens/" },
                    { name: "Creatine", link: "/shop/creatine/" },
                    { name: "Fiber", link: "/shop/fiber/" },
                    { name: "Collagen", link: "/shop/collagen/" },
                ],
        },
        { name: "Subscription", link: "/app/subscription/" },
        { name: "RD Hub", link: "/app/dietitian/" },
    ];
    const notLoggedInMenuLinks = [
        {
            name: "Products",
            link: "/products/",
            additionalLinks: [
                { name: "Protein", link: "/product/protein/" },
                { name: "Hydration", link: "/product/hydration/" },
                { name: "Pre-Workout", link: "/product/preworkout/" },
                { name: "Performance Boosts", link: "/product/boosts/" },
            ],
        },
        {
            name: "Science",
            link: "/science/",
            additionalLinks: [
                {
                    name: "Science advisory board",
                    link: "/science/",
                },
                {
                    name: "Ingredients",
                    link: "/ingredients/",
                },
            ],
        },
        { name: "About Us", link: "/mission/" },
        { name: "Gift Card", link: "/giftcard/" },
    ];
    const dropMenuLinks = user.user_class === "byb"
        ? [
            {
                name: "Account Settings",
                link: "/app/settings/",
            },
            {
                name: referralCTACopy,
                link: "/app/referral/",
            },
            { name: "Orders", link: "/app/order-history/" },
        ]
        : [
            { name: "About You", link: "/app/profile/" },
            {
                name: "Account Settings",
                link: "/app/settings/",
            },
            {
                name: referralCTACopy,
                link: "/app/referral/",
            },
            { name: "Orders", link: "/app/order-history/" },
        ];
    const logout = () => {
        const shopCart = localStorage.getItem("shop-store");
        if (shopCart) {
            const parsedCart = JSON.parse(shopCart);
            parsedCart.state.cart = [];
            localStorage.setItem("shop-cart", JSON.stringify(parsedCart));
        }
        window.location.href = "/logout";
    };
    const goToProfile = () => {
        window.location.href = "/app/home/";
    };
    const goToQuiz = () => {
        window.location.href = "/quiz/quiz_new/";
    };
    const isGiftCardPath = location.pathname.indexOf("giftcard") > -1;
    const isReferralPath = location.pathname.indexOf("referral") > -1;
    useEffect(() => {
        if (profileActive) {
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "unset";
        }
        () => (document.body.style.overflow = "unset");
    }, [profileActive]);
    const referralButton = !isReferralPath && (_jsx(Button, { size: "small", href: "/app/referral/", color: "info", children: "Get 40%" }));
    return (_jsx(_Fragment, { children: _jsxs("div", { className: `${styles["fixed-top"]} ${!userLoggedIn ? styles["fixed-top-not-logged-in"] : ""} ${profileActive ? styles["navbar-active"] : ""} ${hasBannerData ? styles["banner-active"] : ""}`, id: "profile-nav", children: [_jsxs("div", { className: `${styles["fully-spaced-row"]} ${!userLoggedIn && styles.desktop_not_logged_in} ${styles["desktop-profile-nav-wrapper"]} hide-on-med-and-down`, children: [_jsx("a", { href: "/", className: `${styles["nav-flex-elem"]} ${styles.equalWidth}`, "data-attr": "home-link", children: _jsx("img", { className: styles["profile-nav-desktop-logo"], src: squareLogo, alt: "Logo" }) }), _jsx(SiteLinks, { links: userLoggedIn && !isGiftCardPath ? siteMenuLinks : notLoggedInMenuLinks }), _jsxs("div", { className: `${styles["nav-flex-elem"]} ${styles["flex-center"]} ${styles["cursor-pointer"]} ${styles["desktop-icon-container"]}  ${styles.equalWidth}`, children: [_jsx("div", { className: `${styles.desktopReferralCtaWrapper}`, children: referralButton }), userLoggedIn ? (_jsxs("button", { "data-attr": "dropdown-menu-button", type: "button", className: styles.menu_button, onClick: handleClick, children: [_jsx(UserIcon, { name: userName }), open ? _jsx(KeyboardArrowUp, { style: { color: "#333" } }) : _jsx(KeyboardArrowDown, { style: { color: "#333" } })] })) : (_jsxs("div", { className: styles.unlogged_buttons, children: [_jsx("a", { "data-attr": "sign-in-button", href: "/login", className: styles.sign_in, children: "SIGN IN" }), _jsx(RoundedGainfulButton, { dataAttr: "header-go-to-quiz-button", extraClassName: styles.personalize, label: "Take the Quiz", onClick: goToQuiz })] }))] })] }), _jsx("div", { className: "hide-mobile-nav-only", children: _jsxs("div", { className: styles["fully-spaced-row"], children: [_jsx("div", { className: `${styles["nav-left"]} ${styles["nav-flex-elem"]}`, onClick: () => !userLoggedIn && toggleActive && toggleActive(), tabIndex: 0, onKeyUp: () => !userLoggedIn && toggleActive && toggleActive(), role: "button", "data-attr": "mobile-menu-button", children: userLoggedIn ? (referralButton) : (_jsx("div", { className: styles["hamburger-container"], children: _jsxs("div", { id: "menu-icon", className: `${styles["menu-icon"]} ${mainActive && styles.active}`, children: [_jsx("span", { className: "line-1" }), _jsx("span", { className: "line-3" })] }) })) }), _jsx("div", { className: styles["nav-flex-elem"], children: _jsx("a", { "data-attr": "mobile-logo-button", href: "/", children: _jsx("img", { className: styles.mobileNavLogo, src: squareLogo, alt: "squareLogo" }) }) }), _jsxs("div", { className: `${styles["nav-flex-elem"]} ${styles["nav-right"]} ${styles["flex-center"]}`, children: [_jsxs(Menu, { id: "basic-menu", anchorEl: anchorEl, open: open, onClose: handleClose, transformOrigin: { horizontal: "center", vertical: "center" }, classes: {
                                            paper: styles.menu,
                                        }, children: [userLoggedIn &&
                                                !isGiftCardPath &&
                                                dropMenuLinks.map((item) => item.name && (_jsx(MenuItem, { classes: {
                                                        root: styles.menu_item,
                                                    }, onClick: () => handleClose(item.link), "data-attr": "mobile-menu-link-" + item.name, children: _jsx("span", { className: styles.menu_text, children: item.name }) }, item.name))), userLoggedIn && isGiftCardPath && (_jsx(MenuItem, { classes: {
                                                    root: styles.menu_item,
                                                }, onClick: goToProfile, "data-attr": "mobile-menu-link-profile", children: _jsx("span", { className: styles.menu_text, children: "My Profile" }) })), userLoggedIn && (_jsx(MenuItem, { classes: {
                                                    root: [styles.menu_item, styles.menu_logout].join(" "),
                                                }, onClick: logout, "data-attr": "mobile-menu-link-logout", children: _jsx("span", { className: styles.menu_text, children: "Logout" }) }))] }), _jsx("button", { type: "button", className: styles.menu_button, onClick: handleClick, "data-attr": "mobile-menu-dropdown-button", children: userLoggedIn && (_jsxs(_Fragment, { children: [_jsx(UserIcon, { name: userName }), open ? (_jsx(KeyboardArrowUp, { style: { color: "#333" } })) : (_jsx(KeyboardArrowDown, { style: { color: "#333" } }))] })) })] })] }) })] }) }));
};
export default Header;
